import { Container, VStack } from '@chakra-ui/react';

import { DefaultLayout } from '../templates/DefaultLayout';
import { PageSendButton } from '../atom/button/PageSendButton';
import { useHome } from '../hooks/useHome';

export const Home = () => {
  const {
    handleTeikihoan,
    handleKaisen,
    handleHeisen,
    handleGasTen,
    handleHeikaisen, //2025.01 COMTEC kawaji ADD
  } = useHome();

  return (
    <DefaultLayout>
      <Container maxW="container.sm">
        <VStack mt={10}>
          <PageSendButton
            type="button"
            text="定期保安"
            onClick={handleTeikihoan}
            hidden={true}
          />
          <PageSendButton
            type="button"
            text="開栓"
            onClick={handleKaisen}
            hidden={true}
          />
          <PageSendButton
            type="button"
            text="閉栓"
            onClick={handleHeisen}
            hidden={true}
          />
          <PageSendButton
            type="button"
            text="ガス展イベント"
            onClick={handleGasTen}
            //hidden={true}
          />
          {/* 2025.01 COMTEC kawaji ADD START */}
          <PageSendButton
            type="button"
            text="閉開栓"
            onClick={handleHeikaisen}
            hidden={true}
          />
          {/* 2025.01 COMTEC kawaji ADD END */}
        </VStack>
      </Container>
    </DefaultLayout>
  );
};
